import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	scanQrInstructions: {
		id: 'partner.success.scanQrInstructions',
		defaultMessage: 'Scan the QR code to easily download the Calm mobile app.',
		description: 'Instructions for scanning the QR code to download the app.',
	},
});
